import { combineClasses } from "@citychallenge/core";
import { FC } from "react";

import styles from "./spinner.module.scss";

export interface SpinnerProps {
  stroke?: string;
  fullscreen?: boolean;
  size?: "medium" | "small";
}

export const Spinner: FC<SpinnerProps> = ({
  fullscreen,
  stroke,
  size = "medium",
}) => {
  const spinner = (
    <div
      className={combineClasses(styles.loader, styles[size])}
      data-loader
      style={{
        borderColor: stroke,
      }}
    />
  );
  return fullscreen ? (
    <div className={styles.fullscreen}>{spinner}</div>
  ) : (
    spinner
  );
};
